import React from "react";
import ReactSlider from "react-slider";

export const RangeWrapper = ({
  min,
  max,
  minValue,
  maxValue,
  value,
  onChange,
  startingType,
  endingType,
  startingPlaceholder,
  endingPlaceholder,
  minStep
}) => {
  return (
    <div className="range-box-wrapper d-flex justify-content-between gap-3">
      <div className="d-flex flex-column">
        <span className="range-year">
          {/* {minValue} {startingType} */}
        </span>
        <span className="range-validate">{minValue}{startingType}</span>
      </div>
      <ReactSlider
        className="horizontal-slider"
        thumbClassName="example-thumb"
        trackClassName="example-track"
        max={max}
        min={min}
        defaultValue={value}
        onChange={onChange}
        minDistance={minStep}
        pearling
        withTracks
        value={value}
      />
      <div className="d-flex flex-column">
        <span className="range-year">
          {/* {maxValue} {endingType} */}
        </span>
        <span className="range-validate"> {maxValue}{endingType}</span>
      </div>
    </div>
  );
};
